module.exports = __webpack_public_path__ + "static/quote-1bcf94e57320ad4cd727a904a3bdd8a4.png";